import { Skeleton } from "@/components/ui/skeleton";

/** 「我的智能体」加载中与空状态卡片同尺寸，避免布局跳动 */
export function MyAgentsSectionSkeleton() {
  return (
    <div
      className="rounded-2xl overflow-hidden relative"
      style={{
        background:
          "linear-gradient(135deg, rgba(100,140,200,0.015) 0%, #0c1020 40%, #080c18 100%)",
        border: "1px solid rgba(100,140,200,0.06)",
        boxShadow: "0 2px 20px rgba(100,140,200,0.02)",
      }}
      aria-busy="true"
    >
      <div
        className="h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent 10%, rgba(100,140,200,0.08) 50%, transparent 90%)",
        }}
      />
      <div className="flex" style={{ minHeight: 0 }}>
        <div
          className="relative flex flex-col items-center justify-center overflow-hidden"
          style={{
            width: "42%",
            minHeight: "180px",
            backgroundColor: "#0a0e1a",
            backgroundImage:
              "radial-gradient(ellipse at center 60%, rgba(100,140,200,0.08) 0%, #0a0e1a 60%)",
          }}
        >
          <Skeleton className="w-[72%] max-w-[120px] aspect-square rounded-xl border-0 bg-[rgba(100,140,200,0.14)]" />
        </div>
        <div
          className="flex-1 py-3.5 pr-3.5 pl-1 space-y-2.5"
          style={{ minWidth: 0 }}
        >
          <div className="flex items-center gap-2 flex-wrap">
            <Skeleton className="h-4 flex-1 max-w-[148px] rounded-md bg-[rgba(100,140,200,0.14)]" />
            <Skeleton className="h-4 w-11 rounded-md ml-auto bg-[rgba(100,140,200,0.10)]" />
          </div>
          <Skeleton className="h-3 w-[88%] max-w-[210px] rounded bg-[rgba(100,140,200,0.10)]" />
          <Skeleton className="h-10 w-full rounded-xl bg-[rgba(100,140,200,0.12)]" />
        </div>
      </div>
    </div>
  );
}
